import React from 'react'
import { Spinner } from '../Spinner/Spinner'

interface IOutineButton {
  label: string
  handleClick?: any
  type?: any
  isLoading?: boolean
  disabled? : boolean
  color? : string
  className?: string
  
}

export function ButtonPrimary({ label, handleClick, type, isLoading, color, disabled, className }: IOutineButton): JSX.Element {
  return (
    <button
      className={`flex justify-center items-center ${disabled? 'bg-opacity-60': ''}  border rounded-sm h-10 w-24 md:w-36 text-xs font-Inter font-semibold capitalize  ${color? color : 'border-[#023E7D] bg-[#023E7D]  text-white'} ${className}`}
      onClick={handleClick}
      type={type}
      disabled={isLoading || disabled}
    >
      {isLoading ? (<Spinner />) : label}
    </button>
    );
}
